import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Entity, Video, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps, useLang, VideoImage } from '@shapeable/ui';
import { VideoMeta } from './video-meta';

const cls = classNames('video-card');

// -------- Types -------->

export type VideoCardProps = Omit<EntityCardProps, 'entity'> & { 
  entity: Video;
  linkEntireCard?: boolean;
};

export const VideoCardDefaultProps: Omit<VideoCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  descriptionMaxLines: 4,

};


// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ImageStyles = breakpoints({
  base: css`
    
  `,
});



// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Image: styled(VideoImage)`${ImageStyles}`,
    Meta: styled(VideoMeta)``,
};

export const VideoCard: Shapeable.FC<VideoCardProps> = (props) => {
  const { className, children, entity, linkEntireCard, ...rest } = props;
  
  const t = useLang();

  return (
    <My.Container 
      {...rest}
      showExternalLink={false}
      entity={entity}
      useLink={false}
      image={<My.Image entity={entity} />}
      meta={
        <My.Meta 
          entity={entity}
        />
      }
      className={cls.name(className)}>
      {children}
    </My.Container>
  )
};


VideoCard.defaultProps = VideoCardDefaultProps;
VideoCard.cls = cls;
